import { DraggingState } from "./interfaces";

export const PORTAL_TARGET_ID = "mobile-dashboard";
export const WIDGET_GAP_Y = 22.5;

const ADD_CONTAINER_HEIGHT = 15; // padding 1rem

export const getDateKey = (date: Date, selected: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const selMonth = selected.getMonth() + 1;

    return `${year}-${month}-${day}-${selMonth}`;
};

export const initContainerHeight = (state: DraggingState) => {
    if (!state.container) {
        return;
    }

    let height = 0;

    state.container
        .querySelectorAll<HTMLElement>("[data-widget]")
        .forEach((element) => (height += element.offsetHeight + WIDGET_GAP_Y));
    height = Math.max(0, height - WIDGET_GAP_Y);

    state.container.style.setProperty("--c-height", `${height}px`);
    state.containerHeight = height + ADD_CONTAINER_HEIGHT;
};

export const adjustContainerHeight = (state: DraggingState, diff: number) => {
    if (!state.container) {
        return;
    }

    const newBase = state.containerHeight - ADD_CONTAINER_HEIGHT + diff;

    state.containerHeight = newBase + ADD_CONTAINER_HEIGHT;
    state.container.style.setProperty("--c-height", `${newBase}px`);
};
